// extracted by mini-css-extract-plugin
export default {"ticketTotal":"I0LB1Y","price":"UKHLDc","quantity":"wN9_vm"};